export default __webpack_public_path__ + "static/media/polygon.910e1faf.png";